<script setup>
import BarChart from '@/components/Graphs/BarChart';

export default {
    components: { BarChart },
    props: { chartData: null },
    data() {
        return {
            chartDataMaxTicks: [],
            newChartData: {
                labels: [],
                datasets: [],
                x_stacked: false,
                y_stacked: false,
            },
            chartOptions: {
                responsive: true,
            },
        };
    },
    watch: {
        chartData(val) {
            this.newChartData.datasets = val.dataSets;
            this.newChartData.labels = val.labels;
        },
    },
};
</script>

<template>
    <BarChart
        :chartdata-sets="newChartData.datasets"
        :chartdata-labels="newChartData.labels"
        :max-ticks="chartDataMaxTicks"
        :x-stacked="false"
        :y-stacked="false"
    />
</template>

<style scoped lang="scss"></style>
